import Report from './Report.container';

export default Report;
